import { Grid, Link, Paper, Typography } from "@mui/material";
import { FC } from "react";
import { CardInfo } from "../../../components/common/cardInfo/CardInfo";
import ButtonUI from "../../../components/button/buttons";
import { ListUI } from "../../../components/common/listUI/listUI";
import DownloadIcon from "@mui/icons-material/Download";
import InstallDesktopIcon from "@mui/icons-material/InstallDesktop";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import { AutoHiddenInput } from "../../../components/inputs/autohidden.inputs";
import userFetchProfile from "../../../service/userProfile/userProfile";
import { useNavigate } from "react-router-dom";

interface IProps {}

const Wordpress: FC<IProps> = (props) => {
  const storedToken = sessionStorage.getItem("userData");
  const navigate = useNavigate();

  const { profile, loading, error } = userFetchProfile(storedToken || "");

  const steps = [
    {
      title: "Paso 1: Descargar el Plugin",
      description: <>Descarga el plugin desde el botón de arriba.</>,
      icon: <DownloadIcon color="primary" />,
    },
    {
      title: "Paso 2: Instalar el Plugin",
      description: (
        <>
          Instala el plugin en tu panel de administración de{" "}
          <Link href="#" underline="hover">
            WordPress
          </Link>
          .
        </>
      ),
      icon: <InstallDesktopIcon color="primary" />,
    },
    {
      title: "Paso 3: Activar el Plugin",
      description: (
        <>
          Activa el plugin en la sección de plugins de tu panel de
          administración.
        </>
      ),
      icon: <CheckCircleIcon color="primary" />,
    },
    {
      title: "Paso 4: Configurar el Plugin",
      description: (
        <>
          Ve a la configuración del plugin y completa los{" "}
          <Link href="#" underline="hover">
            campos requeridos
          </Link>
          .
        </>
      ),
      icon: <SettingsIcon color="primary" />,
    },
  ];

  return (
    <Paper elevation={2} sx={{ p: 1 }}>
      <h2> Integración del Plugin de Pagos Fiables en WordPress</h2>

      <CardInfo message="Descarga e integra el plugin de Pagos Fiables en tu sitio web WordPress para aceptar pagos de forma segura y eficiente." />

      <Grid container spacing={3} sx={{ mt: 1 }}>
        {/* Sección descarga */}
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Descarga del Plugin
          </Typography>

          <ButtonUI
            title="Descargar plugin"
            variant="contained"
            color="primary"
          ></ButtonUI>
        </Grid>

        {/* Sección pasos */}
        <Grid item xs={12}>
          <Typography sx={{ mt: 2 }} gutterBottom>
            Sigue estos pasos para integrar el plugin de Pagos Fiables en tu
            sitio web WordPress:
          </Typography>
          <ListUI steps={steps} />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Configuración de la API
          </Typography>

          <Typography gutterBottom>
            Para configurar la API, necesitas obtener la <b>API Key</b>, el{" "}
            <b>Client ID</b> de tu cuenta de Pagos Fiables.
          </Typography>

          {/* Contenedor de inputs */}

          <Grid item xs={12} md={6}>
            <AutoHiddenInput value={profile?.data?.response?.data?.static_token} label="API Key" />
          </Grid>

          <Grid item xs={12} md={6}>
            <AutoHiddenInput  value={profile?.data?.response?.data?.id_payment} label="Client ID"  />
          </Grid>

          {/* Botón alineado a la derecha */}
          <Grid container justifyContent="flex-end" sx={{ mt: 3 }}>
            <Grid item>
              <ButtonUI title="Regresar"  onClick={() => navigate('/integraciones')}/>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Wordpress;
